ACC.global = {

    _autoload: [
        'bindPolyfills',
        'bindToggleOffcanvas',
        'bindToggleXsSearch',
        'initImager',
        'backToHome',
        'bindDropdown',
        'closeAccAlert',
        'bindModalPopupInfo',
        'bindRadioToggleWithChildContent',
        'bindCopyToClipboard',
        'showRadioChildContentIfChecked',
        'bindSelectOrganizationButton',
    ],

    // Polyfills should go here untill we put them in separate file
    bindPolyfills() {
        // endsWith polyfill for IE
        if (!String.prototype.endsWith) {
            // eslint-disable-next-line no-extend-native
            String.prototype.endsWith = function (searchString, position) {
                const subjectString = this.toString();
                // eslint-disable-next-line max-len,no-restricted-globals
                if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
                    position = subjectString.length;
                }
                position -= searchString.length;
                const lastIndex = subjectString.indexOf(searchString, position);
                return lastIndex !== -1 && lastIndex === position;
            };
        }
    },

    bindToggleOffcanvas() {
        $(document).on('click', '.js-toggle-sm-navigation', () => {
            ACC.global.toggleClassState($('main'), 'offcanvas');
            ACC.global.toggleClassState($('html'), 'offcanvas');
            ACC.global.toggleClassState($('body'), 'offcanvas');
            ACC.global.resetXsSearch();
        });
    },

    bindToggleXsSearch() {
        $(document).on('click', '.js-toggle-xs-search', () => {
            ACC.global.toggleClassState($('.site-search'), 'active');
            ACC.global.toggleClassState($('.js-mainHeader .navigation--middle'), 'search-open');
        });
    },

    resetXsSearch() {
        $('.site-search').removeClass('active');
        $('.js-mainHeader .navigation--middle').removeClass('search-open');
    },

    toggleClassState($e, c) {
        // eslint-disable-next-line no-unused-expressions
        $e.hasClass(c) ? $e.removeClass(c) : $e.addClass(c);
        return $e.hasClass(c);
    },

    initImager(elems) {
        elems = elems || '.js-responsive-image';
        // eslint-disable-next-line no-undef
        this.imgr = new Imager(elems);
    },

    reprocessImages(elems) {
        elems = elems || '.js-responsive-image';
        if (this.imgr === undefined) {
            this.initImager(elems);
        } else {
            this.imgr.checkImagesNeedReplacing($(elems));
        }
    },

    // usage: ACC.global.addGoogleMapsApi("callback function"); // callback function name like "ACC.global.myfunction"
    addGoogleMapsApi(callback) {
        if (callback !== undefined && $('.js-googleMapsApi').length === 0) {
            // eslint-disable-next-line max-len
            $('head').append(`<script class="js-googleMapsApi" type="text/javascript" src="//maps.googleapis.com/maps/api/js?key=${ACC.config.googleApiKey}&sensor=false&callback=${callback}"></script>`);
        } else if (callback !== undefined) {
            // eslint-disable-next-line no-eval
            eval(`${callback}()`);
        }
    },

    backToHome() {
        $('.backToHome').on('click', () => {
            const sUrl = ACC.config.contextPath;
            window.location = sUrl;
        });
    },

    bindDropdown() {
        // $(document).on("click", ".dropdown-toggle", dropdownToggle);
        $(document).on('click', '.dropdown-menu', (e) => {
            if (!ACC.login.showLeaveRegistrationPopup()) {
                e.stopPropagation(); // prevent close when click inside
            }
        });
    },

    closeAccAlert() {
        $('.closeAccAlert').on('click', function () {
            $(this).closest('.getAccAlert').remove();
        });
    },

    bindModalPopupInfo() {
        $('.js-modal-popup').on('click', function (event) {
            // Only needed if button is "a" tag
            event.preventDefault();

            $('#cboxOverlay').css({ 'background-color': 'rgba(0, 0, 0, 0.8)' });

            const $this = $(this);
            // Get modal content URL
            const href = event.target.getAttribute('data-source-href');
            // Adjust custom settings for modal
            let customModalSettings;

            if (event.target.hasAttribute('data-source-fully-modal')) {
                customModalSettings = {
                    escKey: false,
                    overlayClose: false,
                    closeButton: false,
                    trapFocus: true,
                };
            }

            // Fake URL attr and force modal to load data asynchronous
            $this.attr('href', href);
            // Open modal
            $modal.open(this, customModalSettings);

            setTimeout(() => {
                ACC.global.showRadioChildContentIfChecked();
            }, 200);
        });
    },

    bindRadioToggleWithChildContent() {
        // eslint-disable-next-line no-use-before-define
        $(':input[data-radio-toggle-child]').on('click', manageRadioChildVisibility);
        // eslint-disable-next-line no-use-before-define
        $('#colorbox').on('click', ':input[data-radio-toggle-child]', manageRadioChildVisibility);
    },

    showRadioChildContentIfChecked() {
        const checkedRadioChild = $(':input[data-radio-toggle-child]:checked');
        if (checkedRadioChild) {
            $(`[data-radio-child-group='${checkedRadioChild.attr('name')}']`).hide();
            $(`[data-radio-child='${checkedRadioChild.attr('id')}']`).show();
        }
    },

    bindCopyToClipboard() {
        // eslint-disable-next-line no-new,no-undef
        new ClipboardJS('.js-copy-to-clipboard');
    },

    submitContextSwitchModalPopupForm() {
        const form = $('#contextSwitchForm');
        const showMergeCartsTrigger = $('#showMergeCartsTrigger');
        // eslint-disable-next-line no-unused-vars
        const targetUrl = form.data('target-url');
        $.ajax({
            type: 'POST',
            url: form.data('action'),
            data: form.serialize(),
            complete(data) {
                if (data.status === 205) {
                    window.shouldReload = true;
                } else if (form.data('showMessage')) {
                    $('#mergedPartiesMessageId').addClass('hidden');
                    $('.js-context-account-menu  > ul').removeClass('hidden');
                }
                // eslint-disable-next-line no-unused-expressions
                showMergeCartsTrigger.length ? showMergeCartsTrigger.click() : ACC.global.reloadOrCloseModal();
            },
        });
    },

    submitCartContextSwitchModalPopupForm() {
        const form = $('#contextSwitchForm');
        const isQuoteCheckout = form.data('quote-checkout');
        const quoteActionBtn = '.js-create-quote-button';
        const checkoutActionBtn = '.js-continue-checkout-button';
        $.ajax({
            type: 'POST',
            url: form.data('action'),
            data: form.serialize(),
            complete() {
                if (isQuoteCheckout === 'true') {
                    ACC.checkout.continueQuoteCheckout(quoteActionBtn);
                } else {
                    ACC.checkout.continueCheckout(checkoutActionBtn);
                }
            },
        });
    },

    contextSwitchModalTrigger() {
        $.get($('#contextSwitchModalTrigger').data('modal-show-url'), (isLoginContextVisible) => {
            if (isLoginContextVisible) {
                $('#contextSwitchModalTrigger').trigger('click');
            }
        });
    },

    reloadOrCloseModal() {
        if (window.shouldReload) {
            window.location.reload();
        }
        $modal.close();
    },

    bindSelectOrganizationButton() {
        $('#cboxWrapper').on('click', '.modal-content--container', () => {
            $modal.close();
            $('#existingOrg').click();
        });
    },
};

function manageRadioChildVisibility(e) {
    $(`[data-radio-child-group='${e.target.getAttribute('name')}']`).hide();
    $(`[data-radio-child='${e.target.id}']`).show();
}

// ***** Dropdown begins *****
function dropdownParent($this) {
    let selector = $this.attr('href');
    selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7

    const $parent = selector && $(selector);

    return $parent && $parent.length ? $parent : $this.parent();
}

function dropdownClearMenus(e) {
    // if right click, exit
    if (e && e.which === 3) return;

    // remove class added on dropdownToggle
    $('.dropdown-backdrop').remove();

    $('.dropdown-toggle').each(function () {
        const $parent = dropdownParent($(this));
        // eslint-disable-next-line no-unused-vars
        const relatedTarget = { relatedTarget: this };

        if (!$parent.hasClass('open')) return;

        if (e && e.type === 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) {
            return;
        }

        $parent.removeClass('open');
    });
}

// eslint-disable-next-line no-unused-vars
function dropdownToggle(e) {
    const $this = $(this);

    if ($this.is('.disabled, :disabled')) return;

    const $parent = dropdownParent($this);
    const isActive = $parent.hasClass('open');

    dropdownClearMenus();

    if (!isActive) {
        if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
            $(document.createElement('div'))
                .addClass('dropdown-backdrop')
                .insertAfter($(this))
                .on('click', dropdownClearMenus);
        }

        // eslint-disable-next-line no-unused-vars
        const relatedTarget = { relatedTarget: this };

        if (e.isDefaultPrevented()) return;

        // expand the <ul> on the dropdown
        $this
            .trigger('focus')
            .attr('aria-expanded', 'true');

        // set parent to open
        $parent.toggleClass('open');
    }

    // eslint-disable-next-line consistent-return
    return false;
}
//* **** Dropdown ends *****

/* ###################################################################################################
   ###################################################################################################

   URL sanitization
   @link: https://vanillajstoolkit.com/helpers/sanitizehtml/

 * Sanitize and encode all HTML in a user-submitted string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {String} str  The user-submitted string
 * @return {String} str  The sanitized string
 */
// eslint-disable-next-line no-unused-vars
const sanitizeHTML = function (str) {
    const temp = document.createElement('div');
    temp.textContent = str;
    return temp.innerHTML;
};

/* ###################################################################################################
   ###################################################################################################

   "Number" input behavior prevention

 * Prevents scroll and up/down arrow functionality in "number" inputs.
 * ( see also global.less [ line: 991 - 1008 ] )
 */

$(document).ready(() => {
    // Disable scroll when focused on a number input.
    $('input[type=number]').on('focus', function () {
        $(this).on('wheel', (e) => {
            e.preventDefault();
        });
    });

    // Restore scroll on number inputs.
    $('input[type=number]').on('blur', function () {
        $(this).off('wheel');
    });

    // Set minimun value to be 0
    $('input[type=number]').attr('min', 0);

    // Due to some issues with sanitization inside .jsp pages, all content that we insert with
    // backoffice for modals, we need to relocate outside any "c:" functions to preserve any
    // HTML dom tags.
    if ($('body').hasClass('page-programDetails') || $('body').hasClass('page-programDetailsPageV2')) {
        const modalContent = $('.program-details__attributes .modal-content--container').detach();
        $('body').append(modalContent);
    }
});
